import React from "react";
import * as S from "./styles";
export var Kebob = function Kebob(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 25 24"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    fill: "currentcolor"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M14 12c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    transform: "translate(-319 -248) translate(16 200) translate(303 48)"
  }))))));
};